/**
 * API Endpoints for Groups feature
 * Names match service methods (screaming architecture)
 */

const BASE = "/user_groups";

export const GROUPS_ENDPOINTS = {
  GET_GROUPS: BASE,
  GET_GROUP: (id: string) => `${BASE}/${id}`,
  CREATE_GROUP: BASE,
  UPDATE_GROUP: (id: string) => `${BASE}/${id}`,
  DELETE_GROUP: (id: string) => `${BASE}/${id}`,
  DELETE_GROUPS_BATCH: `${BASE}/destroy_in_batch`,
  ACKNOWLEDGE_GROUP: (id: string) => `${BASE}/${id}/acknowledge`,
  AFFECTED_RESOURCES: (id: string) => `${BASE}/${id}/affected_resources`,
  SEARCH: `${BASE}/search`,
  ANALYZE_MEMBERS_XLSX: (id: string) => `${BASE}/${id}/analyze_members_xlsx_upload`,
  IMPORT_MEMBERS: (id: string) => `${BASE}/${id}/import_members`,
} as const;
